import BigNumber from "bignumber.js";
import { NumberString } from "../number-string";
export class Decimal {
    v;
    constructor(v) {
        this.v = v;
    }
    static of(v) {
        return new Decimal(new NumberString(v));
    }
    toString() {
        return this.v.toValue();
    }
    toNumber() {
        return this.v.toNumber();
    }
    times(n) {
        const d = n instanceof Decimal ? n : Decimal.of(n);
        const result = BigNumber(this.toString()).times(d.toString());
        return Decimal.of(result.toString());
    }
    plus(n) {
        const d = n instanceof Decimal ? n : Decimal.of(n);
        const result = BigNumber(this.toString()).plus(d.toString());
        return Decimal.of(result.toString());
    }
    minus(n) {
        const d = n instanceof Decimal ? n : Decimal.of(n);
        const result = BigNumber(this.toString()).minus(d.toString());
        return Decimal.of(result.toString());
    }
}
//# sourceMappingURL=decimal.js.map